var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Card, CardContent, CardHeader, IconButton, Stack, Typography, } from "@mui/material";
import { useDrop } from "react-dnd";
import { ItemTypes } from "../dnd/ItemTypes";
import { TeamDragger } from "../seasons/TeamDragger";
export var DivisionDropZone = function (_a) {
    var division = _a.division, onEditDivision = _a.onEditDivision, onDeleteDivision = _a.onDeleteDivision, _b = _a.canModify, canModify = _b === void 0 ? false : _b, _c = _a.teams, teams = _c === void 0 ? [] : _c, onTeamDrop = _a.onTeamDrop;
    var _d = __read(useDrop(function () { return ({
        accept: ItemTypes.TEAM,
        drop: function () {
            return { divisionId: division.id };
        },
        collect: function (monitor) { return ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }); },
    }); }), 2), _e = _d[0], canDrop = _e.canDrop, isOver = _e.isOver, drop = _d[1];
    var isActive = canDrop && isOver;
    return (_jsxs(Card, { ref: drop, sx: {
            minHeight: 200,
            backgroundColor: isActive
                ? "action.hover"
                : isOver
                    ? "action.selected"
                    : "background.paper",
            border: canDrop ? "2px dashed" : "1px solid",
            borderColor: isActive
                ? "primary.main"
                : canDrop
                    ? "primary.light"
                    : "divider",
            transition: "all 0.2s ease-in-out",
            cursor: canDrop ? "copy" : "default",
        }, children: [_jsx(CardHeader, { title: _jsx(Typography, { variant: "h6", component: "div", children: division.name }), subheader: _jsxs(Typography, { variant: "caption", color: "text.secondary", children: ["Tier ", division.tier] }), action: canModify && (_jsxs(Stack, { direction: "row", spacing: 0.5, children: [_jsx(IconButton, { size: "small", onClick: function () { return onEditDivision === null || onEditDivision === void 0 ? void 0 : onEditDivision(division.id); }, "aria-label": "edit division", children: _jsx(EditIcon, {}) }), _jsx(IconButton, { size: "small", onClick: function () { return onDeleteDivision === null || onDeleteDivision === void 0 ? void 0 : onDeleteDivision(division.id); }, "aria-label": "delete division", children: _jsx(DeleteIcon, {}) })] })) }), _jsxs(CardContent, { children: [division.description && (_jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 2 }, children: division.description })), teams.length > 0 ? (_jsxs(Box, { children: [_jsxs(Typography, { variant: "subtitle2", sx: { mb: 1 }, children: ["Teams (", teams.length, ")"] }), _jsx(Stack, { spacing: 1, children: teams
                                    .sort(function (a, b) { return (a.name || "").localeCompare(b.name || ""); })
                                    .map(function (team) { return (_jsx(TeamDragger, { team: team, onDrop: onTeamDrop }, team.id)); }) })] })) : (_jsx(Box, { sx: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minHeight: 80,
                            color: "text.secondary",
                            fontStyle: "italic",
                        }, children: _jsx(Typography, { variant: "body2", children: isActive
                                ? "Drop team here"
                                : canDrop
                                    ? "Drop zone for teams"
                                    : "No teams assigned" }) }))] })] }));
};
